import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { ViewColumnComponent } from '../../../../../view-column.component';
import { SubSink } from 'subsink2';
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { BranchPricingSchemeHdrLinkContainerModel } from 'blg-akaun-ts-lib';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsActions} from '../../../branch-settings-controller/actions';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  selectedIndex: number;
  deleteConfirmation: boolean;
}

@Component({
  selector: 'app-util-branch-pricing-schme-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})

export class UtilBranchPricingSchemeCreateComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Create Pricing Scheme';
  protected index = 4;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);


  branchGuid;
  form: FormGroup;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;

  constructor(
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState(a);
    });
    this.form = new FormGroup({
      pricingScheme: new FormControl(),
      level: new FormControl()
    })

  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }

  onSave(){
    const container = new BranchPricingSchemeHdrLinkContainerModel();
    container.bl_fi_mst_branch_pricing_scheme_hdr_link.guid_branch = this.branchGuid;
    container.bl_fi_mst_branch_pricing_scheme_hdr_link.guid_pricing_scheme_hdr = this.form.value.pricingScheme;
    container.bl_fi_mst_branch_pricing_scheme_hdr_link.level_value = this.form.value.level;

    this.branchSettingsStore.dispatch(BranchSettingsActions.createBranchPricingSchemeInit({container:container}));
    this.onReturn();
  }

}
